import {Banner} from '@primer/react'
import {useArchiveDialog} from '../contexts/ArchiveDialogContext'
import {useUnarchiveTask} from '../hooks/use-unarchive-task'

export function ArchiveTaskBanner() {
  const {archiveStatus, setArchiveStatus, dialogState} = useArchiveDialog()
  const repoNwo =
    dialogState.repoOwner && dialogState.repoName ? `${dialogState.repoOwner}/${dialogState.repoName}` : undefined
  const {mutate: unarchiveTask, isPending: isUnarchiving} = useUnarchiveTask({
    taskId: dialogState.taskId,
    repoNwo,
  })

  const handleDismiss = () => {
    setArchiveStatus('idle')
  }

  const handleUndo = () => {
    unarchiveTask(undefined, {
      onSuccess: () => {
        setArchiveStatus('idle')
      },
      onError: () => {
        setArchiveStatus('undo_error')
      },
    })
  }

  if (archiveStatus === 'idle') {
    return null
  }

  if (archiveStatus === 'success') {
    return (
      <Banner
        variant="success"
        title="Session archived"
        hideTitle
        description="The session has been archived successfully."
        onDismiss={handleDismiss}
        primaryAction={
          <Banner.PrimaryAction onClick={handleUndo} disabled={isUnarchiving}>
            {isUnarchiving ? 'Undoing' : 'Undo'}
          </Banner.PrimaryAction>
        }
      />
    )
  }

  if (archiveStatus === 'undo_error') {
    return (
      <Banner
        variant="critical"
        title="Undo failed"
        hideTitle
        description="Failed to undo the archive. Please try again."
        onDismiss={handleDismiss}
      />
    )
  }

  return (
    <Banner
      variant="critical"
      title="Archive failed"
      hideTitle
      description="Failed to archive the session. Please try again."
      onDismiss={handleDismiss}
    />
  )
}
